import { DownloadSimple } from '@phosphor-icons/react';
import { SVG_SIZE_M } from 'src/constants';
import { useDownloadFile } from 'src/hooks';
import { isVideoGenerationCard, Message } from 'src/types';
import { Button } from 'src/v2/commonComponents/Button';

interface DownloadVideoButtonProps {
  message: Message;
  isDisabled: boolean;
}

export const DownloadVideoButton = ({
  isDisabled,
  message,
}: DownloadVideoButtonProps) => {
  const { onDownloadFile } = useDownloadFile();

  const payload = isVideoGenerationCard(message?.payload)
    ? message?.payload
    : undefined;

  if (!payload) {
    return null;
  }

  // (olha): it will work until we support only one video
  const url = payload.videos?.[1]?.video_url;

  const handleDownloadClick = () => {
    if (url) {
      onDownloadFile(url);
    }
  };

  return (
    <Button
      disabled={!url || isDisabled}
      color="secondary-outline"
      onClick={handleDownloadClick}
      tooltipContent="Download to your device"
    >
      <DownloadSimple size={SVG_SIZE_M} />
      Download
    </Button>
  );
};
